import { InMemoryCache } from '@websolutespa/payload-plugin-bowl';
import { ResponseSuccess } from '@websolutespa/payload-utils/server';
import { addDataAndFileToRequest, PayloadHandler, PayloadRequest } from 'payload';
import { fetchRobot } from '../utils/robot';
import { errorHandler } from './error.handler';
import { getApp } from './llmModels.handler';
import { RobotProvider } from './types';

const CACHE_ = new InMemoryCache<RobotProvider[]>();

const getLlmProviders = async () => {
  const cacheKey = 'providers';
  if (CACHE_.has(cacheKey)) {
    return CACHE_.get(cacheKey);
  }
  const providers = await fetchRobot<RobotProvider[]>('api/llm/extension/providers', 'GET');
  CACHE_.set(cacheKey, providers);
  return providers;
};

export const llmProvidersHandler: PayloadHandler = async (req: PayloadRequest) => {
  try {
    await addDataAndFileToRequest(req);
    const { payload } = req;
    await getApp(payload, req);
    const providers = await getLlmProviders();
    return ResponseSuccess(providers);
  } catch (error: any) {
    return errorHandler(error);
  }
};
